import { render, staticRenderFns } from "./GalleryIdent.vue?vue&type=template&id=0d27c8b6"
import script from "./GalleryIdent.vue?vue&type=script&lang=js"
export * from "./GalleryIdent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports